import React from 'react';
import Zoom from '@material-ui/core/Zoom';
import { Fab } from '@material-ui/core';
// import { withStyles } from '@material-ui/core/styles';
// import cx from 'clsx';

// const styles = theme => ({
// });

const AfitdFab = props => {
    const { className, isHidden, children, ...otherProps } = props;

    return (
        <Zoom
            in={!isHidden}
            // timeout={transitionDuration}
            // style={{
            //     transitionDelay: `${value === index ? transitionDuration.exit : 0}ms`,
            // }}
            unmountOnExit
        >
            <Fab className={className} {...otherProps}>
                {children}
            </Fab>
        </Zoom>
    );
};

export default AfitdFab;
// export default withStyles(styles)(AfitdFab);
